import { Constants } from "../shared/constants"

export const coinedEarnData = {
    title:"Reward History",
    type:"coin",
    totol:"250",
    arr:[
        {
            img: Constants.customImages.transactionAvatar1,
            name: "From Myskools",
            coin:60
        },
        {
            img: Constants.customImages.transactionAvatar2,
            name: "From Trainer",
            coin:20
        },
        {
            img: Constants.customImages.transactionAvatar3,
            name: "To Apartment",
            coin:50
        },
    ]

}
   

